import { render, staticRenderFns } from "./ybPagination.vue?vue&type=template&id=0a75fa7c&scoped=true&"
import script from "./ybPagination.vue?vue&type=script&lang=js&"
export * from "./ybPagination.vue?vue&type=script&lang=js&"
import style0 from "./ybPagination.vue?vue&type=style&index=0&id=0a75fa7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a75fa7c",
  null
  
)

export default component.exports